import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Color } from "three";
import { Pass } from "./Pass.js";
/**
 * Used for saving the original clear color of the renderer.
 *
 * @type {Color}
 * @private
 */

var color = new Color();
/**
 * A pass that clears the input buffer or the screen.
 *
 * You can prevent specific bits from being cleared by setting either the
 * autoClearColor, autoClearStencil or autoClearDepth properties of the renderer
 * to false.
 */

export var ClearPass =
/*#__PURE__*/
function (_Pass) {
  _inherits(ClearPass, _Pass);

  /**
   * Constructs a new clear pass.
   *
   * @param {Object} [options] - Additional options.
   * @param {Color} [options.clearColor=null] - An override clear color.
   * @param {Number} [options.clearAlpha=0.0] - An override clear alpha.
   */
  function ClearPass() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ClearPass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ClearPass).call(this, "ClearPass", null, null));
    _this.needsSwap = false;
    /**
     * The clear color.
     *
     * @type {Color}
     */

    _this.clearColor = options.clearColor !== undefined ? options.clearColor : null;
    /**
     * The clear alpha.
     *
     * @type {Number}
     */

    _this.clearAlpha = options.clearAlpha !== undefined ? options.clearAlpha : 0.0;
    return _this;
  }
  /**
   * Clears the input buffer or the screen.
   *
   * @param {WebGLRenderer} renderer - The renderer.
   * @param {WebGLRenderTarget} inputBuffer - A frame buffer that contains the result of the previous pass.
   * @param {WebGLRenderTarget} outputBuffer - A frame buffer that serves as the output render target unless this pass renders to screen.
   * @param {Number} [delta] - The time between the last frame and the current one in seconds.
   * @param {Boolean} [stencilTest] - Indicates whether a stencil mask is active.
   */


  _createClass(ClearPass, [{
    key: "render",
    value: function render(renderer, inputBuffer, outputBuffer, delta, stencilTest) {
      var clearColor = this.clearColor;
      var clearAlpha;

      if (clearColor !== null) {
        color.copy(renderer.getClearColor());
        clearAlpha = renderer.getClearAlpha();
        renderer.setClearColor(clearColor, this.clearAlpha);
      }

      renderer.setRenderTarget(this.renderToScreen ? null : inputBuffer);
      renderer.clear();

      if (clearColor !== null) {
        renderer.setClearColor(color, clearAlpha);
      }
    }
  }]);

  return ClearPass;
}(Pass);